<template>
  <span :ref="sentinalName" />
</template>
<script>
export default {
  name: 'observer.intersectionObserver',
  props: {
    sentinalName: {
      type: String,
      required: true,
    },
    timer: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isIntersectingElement: false,
    };
  },
  watch: {
    isIntersectingElement() {
      if (this.isIntersectingElement === true) {
        this.$emit('on-intersection-element');
      }
    },
  },
  mounted() {
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    const sentinal = this.$refs[this.sentinalName];
    const handler = (entries) => {
      if (entries[0].isIntersecting) {
        this.isIntersectingElement = true;
      } else {
        this.isIntersectingElement = false;
      }
    };
    const observer = new window.IntersectionObserver(handler);
    if (sentinal !== undefined) {
      sleep(this.timer).then(() => {
        observer.observe(sentinal);
      });
    }
  },
};
</script>
